import React from 'react'
import classnames from 'classnames'

import './PeriodSwitch.scss'

interface PeriodSwitchProps {
  readonly isMonthlyPeriod: boolean
  changePeriod(): void
}

const PeriodSwitch: React.FC<PeriodSwitchProps> = props => {
  const { isMonthlyPeriod } = props
  const selectMonthlyPeriod = () => {
    if (!isMonthlyPeriod) { props.changePeriod() }
  }
  const selectYearlyPeriod = () => {
    if (isMonthlyPeriod) { props.changePeriod() }
  }

  return (
    <div className="PeriodSwitch" role="group" aria-label="Billing period">
      <button
        type="button"
        className={classnames('PeriodSwitch__option', {
          'PeriodSwitch__option-active': isMonthlyPeriod,
        })}
        aria-pressed={isMonthlyPeriod}
        data-testid="subscription-billing-monthly"
        onClick={selectMonthlyPeriod}
      >
        Pay monthly
      </button>
      <button
        type="button"
        className={classnames('PeriodSwitch__option', {
          'PeriodSwitch__option-active': !isMonthlyPeriod,
        })}
        aria-pressed={!isMonthlyPeriod}
        data-testid="subscription-billing-yearly"
        onClick={selectYearlyPeriod}
      >
        Pay yearly
      </button>
    </div>
  )
}

export default PeriodSwitch
